function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgEditDetail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22.19 22.19"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, React.createElement("rect", {
    x: 2.13,
    y: 9.11,
    width: 16.89,
    height: 5,
    transform: "translate(-5.11 10.88) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: "0.9921259842519686px"
    }
  }), React.createElement("rect", {
    x: 15.85,
    y: 1.45,
    width: 4.77,
    height: 5,
    transform: "translate(2.55 14.05) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "round",
      strokeWidth: "0.9921259842519686px"
    }
  }), React.createElement("polygon", {
    points: "6.42 19.3 0.46 21.73 2.89 15.76 6.42 19.3",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinejoin: "bevel",
      strokeWidth: "0.9921259842519686px"
    }
  }), React.createElement("polygon", {
    points: "3.82 20.33 0.46 21.73 1.85 18.36 3.82 20.33",
    style: {
      fill: "#666"
    }
  }))));
}

export default __webpack_public_path__ + "static/media/edit-detail.1fbde162.svg";
export { SvgEditDetail as ReactComponent };